import React from 'react'
import { TextInput } from 'SRC/ui/FormElements'

export const Surname = () =>
  <TextInput id='surname' name='surname' label='Prezime' allowedCharacters={['letters']} />
